export const VIMEO_BLUE: string = '#00adef';

export const VIMEO_FOCUSED: string = '#00ADEFFF';

export const FOCUSED_STATE_COLOR: string = 'focus-alt';

export const FAILED_STATUS_COLOR: string = 'status-destructive-primary';

export const CONNECTED_STATUS_COLOR: string = '#28A878';

export const IMPAIRED_STATUS_COLOR: string = '#FFB21E';

export const DISCONNECTED_STATUS_COLOR: string = '#666666';

export const INACTIVE_LAYOUT_COLOR: string = '#666666';

export const LIVE_LAYOUT_COLOR: string = 'status-destructive-primary';

export const WARNING_LAYOUT_COLOR: string = '#FFB21E';

export const PREVIEW_LAYOUT_COLOR: string = '#00ADEF';

export const INCOMING_LAYOUT_COLOR: string = '#0A0A0A';

export const NONE_LAYOUT_COLOR: string = 'transparent';

export const NEUTRAL_PREVIEW_CANVAS_BACKGROUND: string = '#141414';

export const BOKEH_PREVIEW_CANVAS_BACKGROUND: string = '#252D35';

export const PREVIEW_CANVAS_BACKGROUND_BOKEH_DARK: string = '#181E24';

export const PREVIEW_CANVAS_BACKGROUND_BOKEH_LIGHT: string = '#E4E9EF';

export const CORRECT_POLL_COLOR: string = '#28A878';

/**
 * Set of colors used for guest avatars.
 * Based on agora UUID pick color in a deterministic way.
 */
export const RANDOMIZED_AVATAR_COLORS: Array<string> = [
  '#52BA90',
  '#28A878',
  '#1E885C',
  '#F34C35',
  '#E22B12',
  '#C01902',
  '#FFC14B',
  '#FFB21E',
  '#DA920A',
  '#666666',
  '#5CC9FF',
  '#00608F',
];
